import moment from "moment"
import { Link } from "react-router-dom"
import maleSVG from "../../assets/images/male.svg"
export const UserListCard = ({ id, name, email, mobile, role, isActive, createdDate }) => {
    return (

        <tr>
            <td width={"100px"}>
                <span className={isActive == 1 ? "badge badge-pill badge-light-success w-75p py-5" : "badge badge-pill badge-light-danger w-75p py-5"}>
                    {isActive == 1 ? "Active" : "Inactive"}

                </span>
            </td>
            <td width={"200px"}>
                <div className="d-flex justify-content-start align-items-center">
                    <div className="starshot-ring mr-1">
                        <div className="avatar">
                            <div className="text-icon font-lato">{name[0]}</div>
                        </div>
                    </div>

                    <div className="profile-user-info">
                        <strong>{name}</strong>
                        <br />
                        <small>Employee name</small>
                    </div>
                </div>
            </td>
            <td width={"250px"}>
                <strong>{email}</strong>
                <br />
                <small>Email address</small>
            </td>
            <td width={"200px"}>
                <strong>{mobile}</strong>
                <br />
                <small>Phone</small>
            </td>
            <td width={"200px"}>
                <strong>{role}</strong>
                <br />
                <small>Role</small>
            </td>
            <td className="text-right">
                <strong>{moment(createdDate).format("MMM Do YY")}</strong>
                <br />
                <small>Date</small>
            </td>
            <td className="text-right">
                <strong>{moment(createdDate).format("h:mm a")}</strong>
                <br />
                <small>Time</small>
            </td>
            <td>
                <Link
                    to={`/users/${id}/edit`}
                    className="btn btn-primary btn-sm text-white rounded-10 font-11 waves-effect waves-float waves-light"
                >
                    Edit Details
                </Link>
            </td>
        </tr>

    )
}